/*
 * Copyright (c) 2021 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */
import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import OCLCBar from './OCLCBar'
import LegalLinks from './LegalLinks'

const useCustomStyles = makeStyles(() => ({
  footer: {
    marginTop: 'auto',
    width: '100%',
    background: '#FFF',
    borderTop: '0.5px solid #CCCCCC',
  },
}))

/**
 * The footer.
 * @returns {Node} - A react Node.
 */
function Footer() {
  const classes = useCustomStyles()

  return (
    <footer data-testid='page-footer' className={classes.footer}>
      <LegalLinks />
      <OCLCBar />
    </footer>
  )
}

export default Footer
